import React from 'react';
import { cn } from 'src/lib/utils';
import { Label } from './label';

const FormGroup = React.forwardRef(function FormGroup({ className, ...props }, ref) {
  return <div ref={ref} className={cn('mb-5', className)} {...props} />;
});

const FormLabel = React.forwardRef(function FormLabel({ className, ...props }, ref) {
  return <Label ref={ref} className={cn('mb-1.5 block', className)} {...props} />;
});

const FormHint = React.forwardRef(function FormHint({ className, ...props }, ref) {
  return <p ref={ref} className={cn('text-xs text-muted-foreground mt-1.5', className)} {...props} />;
});

const FormError = React.forwardRef(function FormError({ className, children, ...props }, ref) {
  if (!children) return null;
  return (
    <p ref={ref} className={cn('text-xs text-destructive mt-1.5 flex items-center gap-1', className)} {...props}>
      {children}
    </p>
  );
});

export { FormGroup, FormLabel, FormHint, FormError };
